export const LOADING_JOBCARD = "LOADING_JOBCARD";
export const GET_JOBCARD_LIST = "GET_JOBCARD_LIST";
export const GET_JOBCARD_ID = "GET_JOBCARD_ID";
export const REMOVE_JOBCARD = "REMOVE_JOBCARD";
export const ADD_JOBCARD = "ADD_JOBCARD";
export const UPDATE_JOBCARD = "UPDATE_JOBCARD";
export const GET_JOBCARD_DEMAND = "GET_JOBCARD_DEMAND";
export const GET_JOBCARD_FILES = "GET_JOBCARD_FILES";
export const UPDATE_JOBCARD_STATUS = "UPDATE_JOBCARD_STATUS";
export const UPDATE_MULTIPLE_JOBCARD = "UPDATE_MULTIPLE_JOBCARD";
export const GET_JOBCARD_PRIORITY = "GET_JOBCARD_PRIORITY";
export const ADD_JOBCARD_FILE = "ADD_JOBCARD_FILE";
export const ADD_JOBCARD_FILES = "ADD_JOBCARD_FILES";
export const REMOVE_JOBCARD_FILE = "REMOVE_JOBCARD_FILE";
export const GET_JOBCARD_FILES_DOWNLOAD = "GET_JOBCARD_FILES_DOWNLOAD";
export const JOBCARD_ADD_TIMESHEET = "JOBCARD_ADD_TIMESHEET";
export const JOBCARD_TIMESHEET_LOADING = "JOBCARD_TIMESHEET_LOADING";
export const JOBCARD_GET_TIMESHEET_LIST = "JOBCARD_GET_TIMESHEET_LIST";